import { createIdentity } from 'core_main/api/identity';
import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { updateStore } from 'core_main/store';
import { runListenersForEvent } from 'core_main/helpers/events';
import { ON_LOGIN } from 'core/constants';
import { LoginParameters } from './types';
import { init } from '../init';
import { createLoginCallbackResponse } from './helpers';

export const login = (parameters: LoginParameters, cb) => {
  const requestParameters = {
    externalToken: parameters?.jwtToken,
  };

  return maybeFetchCurrentTrackingToken()
    .then(() => createIdentity(requestParameters))
    .then((res) => {
      const callbackResponse = createLoginCallbackResponse(res);

      updateStore('customerId', callbackResponse.customerId);
      updateStore('isPubNubConnected', false);

      init({}, () => {
        if (typeof cb === 'function') cb(callbackResponse);
        runListenersForEvent(ON_LOGIN, callbackResponse);
      });
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      runListenersForEvent(ON_LOGIN, null, error);
      console.error('Failed to identify customer:', error);
    });
};
